import { doc, setDoc } from 'firebase/firestore';
import { userAsPromise } from '../../providers/userProvider';
import { IScoreboardSettings as ILegacyScoreboardSettings } from '../../types';
import { IScoreboardSettings as IExtendedScoreboardSettings } from '../../../ui/sections/scoreboard/types';

/**
 * @description persists the users setting for scoreboard
 * @param settings
 */
export const setScoreboardSettings = async (
  settings: ILegacyScoreboardSettings | IExtendedScoreboardSettings
): Promise<void> => {
  const user = await userAsPromise();

  return setDoc(
    doc(user.services.firestore, `userProfiles/${user.id}/settings/scoreboard`),
    settings,
    { merge: true }
  );
};

/**
 * @description deletes the scoreboard settings in case they get corrupted
 */
export const clearScoreboardSettings = async (): Promise<void> => {
  const user = await userAsPromise();
  return setDoc(
    doc(user.services.firestore, `userProfiles/${user.id}/settings/scoreboard`),
    {}
  );
};
